<form [formGroup]="form" autocomplete="off" (ngSubmit)="save()">
    <h1 mat-dialog-title>Impuestos</h1>
    <div mat-dialog-content>
        <mat-form-field class="medium-width margin-right-small">
            <mat-select formControlName="TaxType" placeholder="Impuesto">
                <mat-option *ngFor="let taxType of taxTypes" [value]="taxType">
                    {{ taxType.Name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.TaxType.errors && f.TaxType.errors.required">
                Seleccione un impuesto
            </mat-error>
        </mat-form-field>

        <mat-form-field class="medium-width margin-right-small">
            <mat-select formControlName="AliquotTax" placeholder="Alícuota">
                <mat-option *ngFor="let aliquotTax of aliquotTaxsFiltered" [value]="aliquotTax">
                    {{ aliquotTax.Percentage }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.AliquotTax.errors && f.AliquotTax.errors.required">
                Seleccione una alícuota
            </mat-error>
        </mat-form-field>

        <mat-form-field class="medium-width margin-right-small">
            <input type="number" placeholder="Importe" matInput formControlName="AmountBase">
            <mat-error *ngIf="f.AmountBase.errors && f.AmountBase.errors.required">
                Ingrese el importe
            </mat-error>
        </mat-form-field>

        <mat-form-field class="full-control">
            <textarea formControlName="Description" matInput placeholder="Descripción"></textarea>
        </mat-form-field>

    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>